import { render, staticRenderFns } from "./ds-search-panel.vue?vue&type=template&id=7a88dcc9&scoped=true"
import script from "./ds-search-panel.vue?vue&type=script&lang=js"
export * from "./ds-search-panel.vue?vue&type=script&lang=js"
import style0 from "./ds-search-panel.vue?vue&type=style&index=0&id=7a88dcc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a88dcc9",
  null
  
)

export default component.exports